var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    rx: 21,
    fill: "white",
    fillOpacity: 0.12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.0228 10.9541H15.9773C13.1646 10.9541 10.9546 13.1641 10.9546 15.9768V26.0223C10.9546 28.835 13.1646 31.045 15.9773 31.045H26.0228C28.8355 31.045 31.0455 28.835 31.0455 26.0223V15.9768C31.0455 13.1641 28.8355 10.9541 26.0228 10.9541ZM29.0364 26.0223C29.0364 27.73 27.7305 29.0359 26.0228 29.0359H15.9773C14.2696 29.0359 12.9637 27.73 12.9637 26.0223V15.9768C12.9637 14.2691 14.2696 12.9632 15.9773 12.9632H26.0228C27.7305 12.9632 29.0364 14.2691 29.0364 15.9768V26.0223Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 15.9766C18.1873 15.9766 15.9773 18.1866 15.9773 20.9993C15.9773 23.812 18.1873 26.022 21 26.022C23.8128 26.022 26.0228 23.812 26.0228 20.9993C26.0228 18.1866 23.8128 15.9766 21 15.9766ZM21 24.0129C19.2923 24.0129 17.9864 22.707 17.9864 20.9993C17.9864 19.2916 19.2923 17.9857 21 17.9857C22.7078 17.9857 24.0137 19.2916 24.0137 20.9993C24.0137 22.707 22.7078 24.0129 21 24.0129Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0224 16.9817C26.5772 16.9817 27.0269 16.532 27.0269 15.9772C27.0269 15.4224 26.5772 14.9727 26.0224 14.9727C25.4676 14.9727 25.0178 15.4224 25.0178 15.9772C25.0178 16.532 25.4676 16.9817 26.0224 16.9817Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/Instagram.8a46f2ace16e2cd1d9c314e04e0cfd9f.svg";
export { ForwardRef as ReactComponent };